import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { MenuItem, SelectField, RaisedButton, Card, CardText, TextField } from "material-ui";
import { Loading, BuscarRecargosExcepcionales, DownloadRecargosArancel, DownloadRecargosFiltrados } from "./actions";
import ErrorSnack from "../../ErrorSnack/view";
import ConsultaRecargosDetalle from "../ConsultaRecargosDetalle/view";
import styles from "../../styles/styles";
import { OpenFiltroBusquedaDetalle } from "../FiltroBusqueda/actions";
import { ObtenerTipoProfesional } from "../../Global/actions";

class FiltroBusquedaRCDetalle extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tipoProfesionalSelected: null,
      codigoPrestacionIsapre: null,
    };
  }

  componentWillMount() {
    this.props.dispatch(ObtenerTipoProfesional());
  }

  DownloadRecargosArancel = () => {
    const filtrosB = {
      RutArancel: this.props.filtrosRecargo.RutArancel,
      CentroAtencion: this.props.filtrosRecargo.CentroAtencion,
      GrupoPrestacion: this.props.filtrosRecargo.GrupoPrestacion,
      TipoProfesional: this.state.tipoProfesionalSelected,
      CodigoPrestacion: this.state.codigoPrestacionIsapre,
    };
    this.props.dispatch(DownloadRecargosArancel(filtrosB));
  }

  DownloadRecargosFiltrados = () => {
    const filtrosB = {
      RutArancel: this.props.filtrosRecargo.RutArancel,
      CentroAtencion: this.props.filtrosRecargo.CentroAtencion,
      GrupoPrestacion: this.props.filtrosRecargo.GrupoPrestacion,
      TipoProfesional: this.state.tipoProfesionalSelected,
      CodigoPrestacion: this.state.codigoPrestacionIsapre,
    };
    this.props.dispatch(DownloadRecargosFiltrados(filtrosB));
  }

  /*
  CambiarCentroAtencion = (event, index, value) => {
    this.props.dispatch(CambiarCentroAtencion(value));
    this.props.dispatch(ObtenerTiposPrestacion(value));
    this.props.dispatch(ObtenerTiposArancel(value));
  }

  CambiarTipoArancel = (event, index, value) => {
    this.props.dispatch(CambiarTipoArancel(value));
  }

  CambiarTipoPrestacion = (event, index, value) => {
    this.props.dispatch(CambiarTipoPrestacion(value));
  }
  */

  CambiarTipoProfesional = (event, index, value) => {
    this.setState({ tipoProfesionalSelected: value });
  }

  CambiarCodPrestacion = (event) => {
    const re = /^[0-9]+$/;
    if (event.target.value === "" || re.test(event.target.value)) {
      this.setState({ codigoPrestacionIsapre: event.target.value });
    }
  }

  BuscarRecargosExcepcionales = () => {
    this.props.dispatch(Loading(true));
    const filtrosB = {
      RutArancel: this.props.filtrosRecargo.RutArancel,
      CentroAtencion: this.props.filtrosRecargo.CentroAtencion,
      GrupoPrestacion: this.props.filtrosRecargo.GrupoPrestacion,
      TipoProfesional: this.state.tipoProfesionalSelected,
      CodigoPrestacion: this.state.codigoPrestacionIsapre,
    };
    this.props.dispatch(BuscarRecargosExcepcionales(filtrosB));
  }

  CerrarModalExcepcionales = () => {
    this.props.dispatch(OpenFiltroBusquedaDetalle(false));
  }

  render() {
    const menuListTipoArancel = [];
    if (this.props.tiposArancel) {
      this.props.tiposArancel.forEach((element) => {
        menuListTipoArancel.push(<MenuItem key={element.Rut} value={element.Rut} primaryText={element.Descripcion} style={styles.customWidthItem} />);
      });
    }

    const menuListCentroAtencion = [];
    if (this.props.centrosAtencion) {
      this.props.centrosAtencion.forEach((element) => {
        menuListCentroAtencion.push(<MenuItem key={element.Secuencia} value={element.Secuencia} primaryText={element.Descripcion} style={styles.customWidthItem} />);
      });
    }

    const menuListTipoPrestaciones = [];
    if (this.props.tiposPrestaciones) {
      this.props.tiposPrestaciones.forEach((element) => {
        menuListTipoPrestaciones.push(<MenuItem key={element.Id} value={element.Id} primaryText={element.Descripcion} style={styles.customWidthItem} />);
      });
    }

    const menuListTipoProfesional = [];
    if (this.props.tiposProfesionales) {
      this.props.tiposProfesionales.forEach((element) => {
        menuListTipoProfesional.push(<MenuItem key={element.Tipo} value={element.Tipo} primaryText={element.Descripcion} style={styles.customWidth} />);
      });
    }

    return (
      <div style={{ width: 990 }}>
        <div style={styles.frameContenidoGeneral}>
          <Card zDepth={0} style={{ paddingBottom: 0 }}>
            <CardText style={{ paddingBottom: 0 }}>
              <div className="row" style={{ paddingBottom: 0 }}>
                <div className="col-12" style={{ margin: 0, padding: 0 }}>
                  <div style={styles.h1}>Consulta de Recargos Convenidos detallados por prestación
                  </div>
                </div>
              </div>
              <div className="row" style={{ paddingBottom: 0 }}>
                <div className="col-4" style={styles.colSelectFieldActualizar}>
                  <div style={styles.floatingClaseSelect}>Rut Institución</div>
                  <TextField
                    name="txt_fbrc_rutinstitucion"
                    id="txt_fbrc_rutinstitucion"
                    value={this.props.rutInstitucion}
                    underlineStyle={styles.underlineSelectField}
                    inputStyle={styles.h4}
                    style={styles.selectFiledStyle}
                    disabled
                  />
                </div>
                <div className="col-4" style={styles.colSelectFieldActualizar}>
                  <div style={styles.floatingClaseSelect}>Centro de Atención</div>
                  <SelectField
                    name="dd_fbrc_centroatencion"
                    id="dd_fbrc_centroatencion"
                    value={this.props.filtrosRecargo.CentroAtencion}
                    // onChange={this.CambiarCentroAtencion}
                    labelStyle={styles.h4}
                    underlineStyle={styles.underlineSelectField}
                    style={styles.selectFiledStyle}
                    iconStyle={styles.iconSelectField}
                    menuItemStyle={styles.menuItemStyleSelectField}
                    selectedMenuItemStyle={styles.selectedMenuItemSelectField}
                    disabled
                  >
                    {menuListCentroAtencion}
                  </SelectField>
                </div>
                <div className="col-4" style={styles.colSelectFieldActualizar}>
                  <div style={styles.floatingClaseSelect}>Tipo de Arancel</div>
                  <SelectField
                    name="dd_fbrc_tipoarancel"
                    id="dd_fbrc_tipoarancel"
                    value={this.props.filtrosRecargo.RutArancel}
                    // onChange={this.CambiarTipoArancel}
                    labelStyle={styles.h4}
                    underlineStyle={styles.underlineSelectField}
                    style={styles.selectFiledStyle}
                    iconStyle={styles.iconSelectField}
                    menuItemStyle={styles.menuItemStyleSelectField}
                    selectedMenuItemStyle={styles.selectedMenuItemSelectField}
                    disabled
                  >
                    {menuListTipoArancel}
                  </SelectField>
                </div>
              </div>
              <div className="row">
                <div className="col-4" style={styles.colSelectFieldActualizar}>
                  <div style={styles.floatingClaseSelect2}>Tipo de Prestación</div>
                  <SelectField
                    name="dd_fbrc_tipoprestacion"
                    id="dd_fbrc_tipoprestacion"
                    value={this.props.filtrosRecargo.GrupoPrestacion}
                    // onChange={this.CambiarTipoPrestacion}
                    labelStyle={styles.h4}
                    underlineStyle={styles.underlineSelectField}
                    style={styles.selectFiledStyle}
                    iconStyle={styles.iconSelectField}
                    menuItemStyle={styles.menuItemStyleSelectField}
                    selectedMenuItemStyle={styles.selectedMenuItemSelectField}
                    disabled
                  >
                    {menuListTipoPrestaciones}
                  </SelectField>
                </div>
                <div className="col-4" style={styles.colSelectFieldActualizar}>
                  <div style={styles.floatingClaseSelect2}>Tipo Profesional</div>
                  <SelectField
                    name="dd_fbrc_tipoprofesional"
                    id="dd_fbrc_tipoprofesional"
                    value={this.state.tipoProfesionalSelected}
                    onChange={this.CambiarTipoProfesional}
                    labelStyle={styles.h4}
                    underlineStyle={styles.underlineSelectField}
                    style={styles.selectFiledStyle}
                    iconStyle={styles.iconSelectField}
                    menuItemStyle={styles.menuItemStyleSelectField}
                    selectedMenuItemStyle={styles.selectedMenuItemSelectField}
                  >
                    {menuListTipoProfesional}
                  </SelectField>
                </div>
                <div className="col-4" style={styles.colSelectFieldActualizar}>
                  <div style={styles.floatingClaseSelect2}>Código Prestación Isapre</div>
                  <TextField
                    name="txt_fbrc_codprestacion"
                    id="txt_fbrc_codprestacion"
                    value={this.state.codigoPrestacionIsapre || ""}
                    onChange={this.CambiarCodPrestacion}
                    errorText=""
                    maxLength={50}
                    underlineStyle={styles.underlineSelectField}
                    inputStyle={styles.h4}
                    style={styles.selectFiledStyle}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-6">
                  <RaisedButton
                    label="Volver"
                    onClick={this.CerrarModalExcepcionales}
                    primary
                    labelStyle={{ fontSize: "11px" }}
                    overlayStyle={{ borderRadius: 5 }}
                    rippleStyle={{ borderRadius: 5 }}
                    style={{ width: "145px", borderRadius: 5, marginLeft: 20 }}
                    buttonStyle={{ borderRadius: 5 }}
                  />
                </div>
                <div className="col-6" style={{ textAlign: "right" }}>
                  {!this.props.loading ?
                    <RaisedButton
                      label="Consultar"
                      onClick={this.BuscarRecargosExcepcionales}
                      secondary
                      labelStyle={{ fontSize: "11px" }}
                      overlayStyle={{ borderRadius: 5 }}
                      rippleStyle={{ borderRadius: 5 }}
                      style={{ width: "145px", borderRadius: 5, marginLeft: 20 }}
                      buttonStyle={{ borderRadius: 5 }}
                    />
                    :
                    <RaisedButton
                      label="Cargando ..."
                      secondary
                      labelStyle={{ fontSize: "11px" }}
                      overlayStyle={{ borderRadius: 5 }}
                      rippleStyle={{ borderRadius: 5 }}
                      style={{ width: "145px", borderRadius: 5, marginLeft: 20 }}
                      buttonStyle={{ borderRadius: 5 }}
                    />
                  }
                </div>
              </div>
            </CardText>
          </Card>
        </div>

        {this.props.busquedarecargos ?
          <ConsultaRecargosDetalle
            DownloadRecargosArancel={this.DownloadRecargosArancel}
            DownloadRecargosFiltrados={this.DownloadRecargosFiltrados}
          />
          : null}

        <div>
        </div>
        <ErrorSnack />
      </div>
    );
  }
}

FiltroBusquedaRCDetalle.propTypes = {
  loading: PropTypes.bool.isRequired,
  busquedarecargos: PropTypes.bool.isRequired,
  rutInstitucion: PropTypes.number.isRequired,
  tiposArancel: PropTypes.array.isRequired,
  centrosAtencion: PropTypes.array.isRequired,
  tiposPrestaciones: PropTypes.array.isRequired,
  tiposProfesionales: PropTypes.array.isRequired,
  // filtros: PropTypes.any.isRequired,
  filtrosRecargo: PropTypes.any.isRequired,
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  loading: state.filtroBusquedaRCDetalle.loading,
  busquedarecargos: state.filtroBusquedaRCDetalle.busquedarecargos,
  rutInstitucion: state.global.rutInstitucion,
  tiposArancel: state.global.filtros_CAT.tiposArancel,
  centrosAtencion: state.global.filtros_CAT.centrosAtencion,
  tiposPrestaciones: state.global.filtros_CAT.tiposPrestaciones,
  tiposProfesionales: state.global.tiposProfesionales,
  // filtros: {
  //   tipoArancel: state.global.filtros_CAT.tipoArancel,
  //   centroAtencion: state.global.filtros_CAT.centroAtencion,
  //   tipoPrestacion: state.global.filtros_CAT.tipoPrestacion,
  //   codFonasa: state.global.filtros_CAT.codFonasa || "",
  //   codPrestacion: state.global.filtros_CAT.codPrestacion || "",
  // },
  filtrosRecargo: state.filtroBusquedaRC.filtrosRecargo,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => { dispatch(action); },
});


export default connect(mapStateToProps, mapDispatchToProps)(FiltroBusquedaRCDetalle);




// WEBPACK FOOTER //
// ./src/components/RecargosConvenios/FiltroBusquedaDetalle/view.jsx